import(/* webpackMode: "eager", webpackExports: ["NewsFeed"] */ "/var/www/light_of_empire_front/widgets/NewsFeed/NewsFeed.tsx");
